import { formatDistanceToNow, differenceInSeconds } from 'date-fns';
import { Subject, Subscription, interval } from 'rxjs';

import { Pipe, PipeTransform, OnDestroy, ChangeDetectorRef, Inject } from '@angular/core';

import { TranslationService } from '@lib/translation';

const MINUTE = 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

@Pipe({
  name: 'snTimeToNow',
  pure: false,
})
export class SnTimeToNowPipe implements PipeTransform, OnDestroy {
  private _date: number;
  private _value: string;

  private _clockSubscription: Subscription;

  private readonly _stateChange$ = new Subject<void>();

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    @Inject(TranslationService) private _translationService: TranslationService
  ) {
    this._stateChange$.subscribe(() => {
      this._value = this._translationService.translateTimeAgo(this._date);
      changeDetectorRef.markForCheck();
    });
  }

  public ngOnDestroy(): void {
    if (this._clockSubscription) {
      this._clockSubscription.unsubscribe();
      this._clockSubscription = null;
    }

    this._stateChange$.complete();
  }


  public transform(value: Date): string {
    if (!value) {
      return;
    }

    const date = new Date(value).valueOf();

    if (this._date === date) {
      return this._value;
    }

    this._date = date;

    if (this._clockSubscription) {
      this._clockSubscription.unsubscribe();
      this._clockSubscription = null;
    }

    if (this._date) {
      const seconds = differenceInSeconds(date, Date.now());

      let period = 0;

      if (seconds < MINUTE) {
        period = 1000;
      } else if (seconds < HOUR) {
        period = MINUTE * 1000;
      } else if (seconds < DAY) {
        period = HOUR * 1000;
      }

      if (period) {
        this._clockSubscription = interval(period).subscribe(() => {
          this._stateChange$.next();
        });
      }

      this._stateChange$.next();
    } else {
      throw new SyntaxError(`
        Wrong parameter in SnTimeToNowPipe.
        Expected a valid date, received: ${date}
      `);
    }

    return this._value;
  }
}
